import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Enum_BranchesFilters } from "../Branches.types";
import { Enum_BranchesInfoRegionFilters } from "common/BranchesInfo/BranchesInfo.types";
import { useMeta } from "hooks";

export interface useBranchesArgs {
  currentPage?: number;
  regionType?: Enum_BranchesFilters | Enum_BranchesInfoRegionFilters;
  placeType?: string;
  pageSize?: number;
}

export const useBranches = ({
  currentPage,
  pageSize,
  regionType = 0,
  placeType = ""
}: useBranchesArgs) => {
  const { language } = useSelector((state: RootState) => state.global);
  const { setMetaTags } = useMeta();

  const PAGE_SIZE = 12;
  const {
    data: branches,
    isLoading,
    isFetching
  } = useQuery(
    [language, currentPage, regionType, placeType, pageSize, "branches"],
    () =>
      publicRequest({
        url: `/api/branches/${language}?page=${currentPage || ""}&per_page=${
          pageSize ? pageSize : PAGE_SIZE
        }&type=${placeType}&is_region=${regionType}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      }
    }
  );

  return {
    branches: branches?.data?.data,
    maxPages: branches?.data?.max_pages,
    isLoading,
    isFetching,
    PAGE_SIZE
  };
};
